
<Form
  v-if="defaultValues"
  class="w-full"
  :defaultValues="defaultValues"
  v-bind="$attrs"
  :before="handleSubmitBefore"
  v-on="$listeners"
>
  <template #default="{ values }">
    <div class="grid grid-cols-2 gap-x-2">
      <Input
        id="extension-package-name"
        v-model="values.name"
        :label="`* ${$t('workspace_rde.catalog.label.package_name')}`"
        :rules="[rules.required, rules.name]"
        appendClass="app-g-input-v2"
        :disabled="!!defaultEditValue"
      />
      <Input
        id="extension-package-display-name"
        v-model="values.displayName"
        :label="`* ${$t('common.base.label.display_name')}`"
        :rules="[rules.required]"
        appendClass="app-g-input-v2"
      />
      <v-textarea
        id="extension-package-description"
        v-model="values.description"
        class="col-span-2 mt-1 app-g-text-area-v2"
        outlined
        :label="$t('workspace_rde.catalog.label.package_description')"
      ></v-textarea>

      <Checkbox
        id="extension-package-type"
        v-model="values.type"
        label="ai-extension"
        true-value="ai-extension"
        false-value=""
      />
    </div>
    <div class="mt-3 mb-3 text-big-label">
      {{ $t("workspace_rde.catalog.label.selected_extensions") }}
    </div>

    <RDECatalogTable
      :value="selectedExtensions"
      show-select
      :headers="headers"
      :items="sortedExtensions"
      item-key="customId"
      item-value="customId"
      :items-per-page="5"
      @input="selectItems"
    >
    </RDECatalogTable>

    <div class="flex justify-end gap-x-2 mt-4">
      <Button :size="'md'" @click="closePopup">
        {{ $t("common.base.button.cancel") }}
      </Button>
      <Button :type="'submit'" color="primary" :size="'md'" text fill>
        {{ $t("common.base.button.save") }}
      </Button>
    </div>
  </template>
</Form>
